import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getMe, selectMe } from "../redux/slices/generalSlice";
import { debounce } from "lodash";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { backendServerBaseURL } from "../utils/backendServerBaseURL";

const UserSidebar = ({ handleCommonToggle }) => {
  const [showAdmin, setShowAdmin] = useState(false);
  const [SocialLinks, setSocialLinks] = useState([]);
  const [navOpen, setnavOpen] = useState(true);
  const [selectedMenu, setselectedMenu] = useState("");
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const me = useSelector(selectMe);

  const loadMeInfo = useCallback(
    debounce(() => {
      dispatch(getMe());
    }, 500),
    []
  );

  const fetchDetails = async () => {
    await axios
      .get(`${backendServerBaseURL}/landing`)
      .then((data) => {
        setSocialLinks(data.data.payload.SocialLinks.value);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchDetails();
    if (me?.role == "User") {
      setShowAdmin(false);
    }
  }, [me]);

  useEffect(() => {
    const storedSelectedMenu = localStorage.getItem("selectedMenu");

    if (storedSelectedMenu) {
      setselectedMenu(storedSelectedMenu);
    } else {
      // Default value when nothing is stored
    }
  }, []); // Empty dependency array, indicating the effect should run once on mount

  // useEffect(()=>{
  //   localStorage.setItem("selectedMenu", selectedMenu);

  // },[selectedMenu]);

  const handleSelectedMenu = (menu) => {
    // if (window.screen.width <= 1200) {
    //   handleToggleClick();
    // }

    setselectedMenu(menu);
    localStorage.setItem("selectedMenu", menu);
  };

  return (
    <div className="d-flex flex-column justify-content-between">
      <div className="d-flex flex-column">
        <div class="logo-box">
          <a href="/">
            <img src="/assets/images/logo.svg" alt="Logo" class="img-fluid logo-big d-light" />
            <img src="/assets/images/dak-mode/logo.svg" alt="Logo" class="img-fluid logo-big d-dark" />
            <img src="/assets/images/icons/favicon.svg" alt="Logo" class="img-fluid logo-small" />
          </a>

          <button
            class="btn btn-toggle"
            type="button"
            id="menuToggle"
            onClick={() => {
              setnavOpen(!navOpen);
              // handleToggleClick();
              handleCommonToggle();
            }}
          >
            <i class="fa fa-angle-left"></i>
          </button>
        </div>

        <div class="menu-set mt-0 border-0 ">
          <h6>MAIN MENU</h6>

          <ul>
            <li
              onClick={() => {
                handleSelectedMenu("dashboard");
              }}
            >
              <Link to={"/dashboard"} className={selectedMenu === "dashboard" ? "active" : "not-active"}>
                <img src="/assets/images/sidebar-icons/home-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/home.svg" alt="icon" class="img-fluid not-active" />
                <span>Dashboard</span>
              </Link>
            </li>
            <li
              onClick={() => {
                handleSelectedMenu("topup");
              }}
            >
              <Link to="/topup" className={selectedMenu === "topup" ? "active" : "not-active"}>
                <img src="/assets/images/sidebar-icons/deposit-balance-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/deposit-balance.svg" alt="icon" class="img-fluid not-active" />
                <span>Deposit Balance</span>
              </Link>
            </li>
            <li
              onClick={() => {
                handleSelectedMenu("invoices");
              }}
            >
              <Link to="/invoices" className={selectedMenu === "invoices" ? "active" : "not-active"}>
                <img src="/assets/images/sidebar-icons/invoice-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/invoice.svg" alt="icon" class="img-fluid not-active" />
                <span>Invoices</span>
              </Link>
            </li>
            <li
              onClick={() => {
                handleSelectedMenu("customers");
              }}
            >
              <Link to="/customers" className={selectedMenu === "customers" ? "active" : "not-active"}>
                <img src="/assets/images/sidebar-icons/customer-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/customer.svg" alt="icon" class="img-fluid not-active" />
                <span>Customers</span>
              </Link>
            </li>
            <li
              onClick={() => {
                handleSelectedMenu("Logs");
              }}
            >
              <Link to="/logs" className={selectedMenu === "Logs" ? "active" : "not-active"}>
                <img src="/assets/images/sidebar-icons/analysis-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/analysis.svg" alt="icon" class="img-fluid not-active" />
                <span>Log</span>
              </Link>
            </li>
            <li
              onClick={() => {
                handleSelectedMenu("Autorefund");
              }}
            >
              <Link to="/auto-refund" className={selectedMenu === "Autorefund" ? "active" : "not-active"}>
                <img src="/assets/images/sidebar-icons/automation-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/automation.svg" alt="icon" class="img-fluid not-active" />
                <span>Auto Refund Logs</span>
              </Link>
            </li>
          </ul>
        </div>

        <div class="menu-set">
          <h6>SUPPORT</h6>
          <ul>
            <li
              onClick={() => {
                handleSelectedMenu("faq");
              }}
            >
              <Link to="/faq" className={selectedMenu === "faq" ? "active" : "not-active"}>
                <img src="/assets/images/sidebar-icons/faq-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/faq.svg" alt="icon" class="img-fluid not-active" />
                <span>FAQs</span>
              </Link>
            </li>
            <li
              onClick={() => {
                handleSelectedMenu("api-docs");
              }}
            >
              <Link to="/api-docs" className={selectedMenu === "api-docs" ? "active" : "not-active"}>
                <img src="/assets/images/sidebar-icons/api-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/api.svg" alt="icon" class="img-fluid not-active" />
                <span>API Docs</span>
              </Link>
            </li>
          </ul>
        </div>

        <div class="menu-set">
          <h6>CONNECT WITH US</h6>
          <ul>
            <li>
              <a href={SocialLinks?.find((s) => s.social === "Discord")?.link || ""}>
                <img src="/assets/images/sidebar-icons/discord-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/discord.svg" alt="icon" class="img-fluid not-active" />
                <span>Join Discord Server</span>
              </a>
            </li>

            <li>
              <a href={SocialLinks?.find((s) => s.social === "Telegram")?.link || ""}>
                <img src="/assets/images/sidebar-icons/telegram-2.svg" alt="icon" class="img-fluid active" />
                <img src="/assets/images/sidebar-icons/telegram.svg" alt="icon" class="img-fluid not-active" />
                <span>Join Telegram Channel</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="sidebar-ftr mt-5">
        <ul>
          <li
            onClick={() => {
              handleSelectedMenu("terms-of-services");
            }}
          >
            <Link to="/terms-of-services">Terms of Service</Link>
          </li>
          <li>
            <span>|</span>
          </li>
          <li>
            <a href="/privacy-policy">Privacy Policy</a>
          </li>
        </ul>

        <ul>
          <li>
            <img
              src={"/assets/images/sidebar-icons/social-01.svg"}
              alt="icon"
              className="img-fluid"
              onClick={() => {
                const targetLink = SocialLinks?.find((s) => s.social === "Telegram")?.link || "";
                window.open(targetLink, "_self");
              }}
              style={{ marginRight: "1rem", cursor: "pointer" }}
            />
          </li>
          <li>
            <img
              src={"/assets/images/sidebar-icons/social-02.svg"}
              alt="icon"
              className="img-fluid"
              onClick={() => {
                const targetLink = SocialLinks?.find((s) => s.social === "Instagram")?.link || "";
                window.open(targetLink, "_self");
              }}
              style={{ marginRight: "1rem", cursor: "pointer" }}
            />
          </li>
          <li>
            <img
              src={"/assets/images/sidebar-icons/social-03.svg"}
              alt="icon"
              className="img-fluid"
              onClick={() => {
                const targetLink = SocialLinks?.find((s) => s.social === "Discord")?.link || "";
                window.open(targetLink, "_self");
              }}
              style={{ marginRight: "1rem", cursor: "pointer" }}
            />
          </li>
          <li>
            <img
              src={"/assets/images/sidebar-icons/social-04.svg"}
              alt="icon"
              className="img-fluid"
              onClick={() => {
                const targetLink = SocialLinks?.find((s) => s.social === "Twitter")?.link || "";
                window.open(targetLink, "_self");
              }}
              style={{ marginRight: "1rem", cursor: "pointer" }}
            />
          </li>
          <li>
            <img
              src={"/assets/images/fb.svg"}
              alt="icon"
              className="img-fluid"
              onClick={() => {
                const targetLink = SocialLinks?.find((s) => s.social === "Facebook")?.link || "";
                window.open(targetLink, "_self");
              }}
              style={{ marginRight: "1rem", cursor: "pointer" }}
            />
          </li>

          {/* {SocialLinks?.map((s, index) => (
            <li>
              <Link to={s.link}>
                <img
                  src={
                    s.social == "Telegram"
                      ? "/assets/images/sidebar-icons/social-01.svg"
                      : s.social == "Instagram"
                      ? "/assets/images/sidebar-icons/social-02.svg"
                      : s.social == "Twitter"
                      ? "/assets/images/sidebar-icons/social-04.svg"
                      : s.social == "Facebook"
                      ? "/assets/images/fb.svg"
                      : s.social == "Discord"
                      ? "/assets/images/sidebar-icons/social-03.svg"
                      : ""
                  }
                  alt="icon"
                  className="img-fluid"
                  onClick={() => {
                    const targetLink = s.link;
                    window.open(targetLink, "_self");
                  }}
                  style={{ marginRight: "1rem", cursor: "pointer" }}
                />
              </Link>
            </li>
          ))} */}
        </ul>
      </div>
    </div>
  );
};

export default UserSidebar;
